<template>
  <div class="errorpage">
    <h1>404</h1>
    <span>Ooops. Looks like this page doesn't exist.</span>
  </div>
</template>

<script>
export default {
  name: '404',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.errorpage {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  & h1 {
    font-size: 200px;
    font-weight: bold;
    margin: 20px 0;
  }
  & span {
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/error/404.vue